<template>
  <v-list v-if="items.length">
    <draggable v-model="items"
               @update="update"
               @start="startMove"
               @end="endMove">
      <template v-for="asset in items">
        <SpaceAssetListItem :asset="asset"
                            :key="asset.id"
                            @updated="updated"
                            @removed="updated">
        </SpaceAssetListItem>
      </template>
    </draggable>
  </v-list>
</template>
<script>
import draggable from 'vuedraggable';
import SpaceAssetListItem from './SpaceAssetListItem.vue';

export default {
  components: {
    SpaceAssetListItem,
    draggable,
  },
  props: {
    assets: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dragging: false,
      enabled: true,
      items: [],
      events: [],
    }
  },
  computed: {},
  watch: {
    assets(val) {
      //console.log('watch()');
      this.updateItems();
    }
  },
  created() {
    //console.log('created()');
    this.updateItems();
  },
  methods: {
    updated() {
      this.$emit('updated');
    },
    updateItems() {
      //console.log('updateItems()');
      this.items = [];
      this.assets.forEach(a => {
        this.items.push(a);
      })
    },
    move(e) {
      this.events.push('move');
      //console.log('move()', e);
      return true;
    },
    // @see https://github.com/SortableJS/Vue.Draggable#events
    update(e) {
      this.events.push('update');
      //console.log('update()', e);
    },
    startMove(e) {
      this.events.push('start');
      //console.log('startMove()', e);
      this.dragging = true;
    },
    endMove(e) {
      this.events.push('end');
      //console.log('endMove()', e);
      this.dragging = false;
      this.$emit('reordered', this.items);
    },
  }
}
</script>
